import { render, staticRenderFns } from "./animated-number.html?vue&type=template&id=0b211564&scoped=true&"
import script from "./animated-number.js?vue&type=script&lang=js&"
export * from "./animated-number.js?vue&type=script&lang=js&"
import style0 from "./animated-number.scss?vue&type=style&index=0&id=0b211564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b211564",
  null
  
)

export default component.exports